import { Ipage } from 'components/Table/type';
import { Ioption } from 'tradevan-ui/type';
import { EnumRetailerSetup, EnumRetailerType } from 'view/Layout/enum';
import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import { useSelector } from 'react-redux';
import { localStorageRetaierIdName, DATE_RANGE_DEFAULT } from 'consts';
import { IexportItemList, IqueryDateList, IquerySort } from 'view/Layout/type';
import { initExportItemList } from 'view/Layout/consts';

// #region Master

export const EnumMaster = {
  /** 體系別 */
  retailerId: 'retailerId',
  /** 廠商編號 */
  supplierCode: 'supplierCode',
  /** 分店/倉庫代碼 */
  storeNo: 'storeNo',
  /** 驗收日期 起 */
  receiveStartDate: 'receiveStartDate',
  /** 驗收日期 訖 */
  receiveEndDate: 'receiveEndDate',
  /** 訂單號碼 起 */
  orderStartNo: 'orderStartNo',
  /** 訂單號碼 訖 */
  orderEndNo: 'orderEndNo',
  /** 驗收單號碼 起 */
  receiveStartNo: 'receiveStartNo',
  /** 驗收單號碼 訖 */
  receiveEndNo: 'receiveEndNo',
  /** 廠編模糊篩選 */
  supplierCodeLike: 'supplierCodeLike',
  /** 日期下拉選單 */
  queryDateValue: 'queryDateValue',
  /** 動態日期 起 */
  queryDateBegin: 'queryDateBegin',
  /** 動態日期 迄 */
  queryDateEnd: 'queryDateEnd',
} as const;

export interface Imaster {
  [EnumMaster.retailerId]: EnumRetailerType | string;
  [EnumMaster.supplierCode]: string[];
  [EnumMaster.storeNo]: string[];
  [EnumMaster.receiveStartDate]: Date | null;
  [EnumMaster.receiveEndDate]: Date | null;
  [EnumMaster.orderStartNo]: string;
  [EnumMaster.orderEndNo]: string;
  [EnumMaster.receiveStartNo]: string;
  [EnumMaster.receiveEndNo]: string;
  [EnumMaster.supplierCodeLike]: string;
  [EnumMaster.queryDateValue]: string | null;
  [EnumMaster.queryDateBegin]: Date | null;
  [EnumMaster.queryDateEnd]: Date | null;
}

// #endregion

// #region Detail

export enum EnumDetail {
  /** 體系別 */
  retailerId = 'retailerId',
  /** 體系別中文 */
  retailerName = 'retailerName',
  /** 分店 */
  buyerGln = 'buyerGln',
  /** 分店倉庫名稱 */
  postBriefName = 'postBriefName',
  /** 驗收單號碼 */
  receiveNo = 'receiveNo',
  /** 驗收日期 */
  deliverDate = 'deliverDate',
  /** 廠編 */
  supplierCode = 'supplierCode',
  /** 廠商簡稱 */
  supplierBriefName = 'supplierBriefName',
  /** 訂單號碼 */
  orderNo = 'orderNo',
  /** 訂單日期 */
  orderDate = 'orderDate',
  /** 驗收單狀態 */
  sourceState = 'sourceState',
  /** 點閱紀錄 */
  viewed = 'viewed',
  /** 文字檔下載紀錄 */
  downloaded = 'downloaded',
  /** 最後異動時間 */
  updDate = 'updDate',
  orderNoCnt = 'orderNoCnt',
  /** 結帳日 */
  closeDate = 'closeDate',
  /** 備註 */
  remark = 'remark',
  /** 送貨結束日期 */
  deliverEndDate = 'deliverEndDate',
  /** 進貨日期 */
  arriveDateTime = 'arriveDateTime',
  /** 結帳月份 */
  billMonth = 'billMonth',
}

export interface Idetail {
  selected: boolean;
  [EnumDetail.retailerId]: string;
  [EnumDetail.retailerName]: string;
  [EnumDetail.buyerGln]: string;
  [EnumDetail.postBriefName]: string;
  [EnumDetail.receiveNo]: string;
  [EnumDetail.deliverDate]: string;
  [EnumDetail.supplierCode]: string;
  [EnumDetail.supplierBriefName]: string;
  [EnumDetail.orderNo]: string;
  [EnumDetail.orderDate]: string;
  [EnumDetail.sourceState]: string;
  [EnumDetail.viewed]: string;
  [EnumDetail.downloaded]: string;
  [EnumDetail.updDate]: string;
  [EnumDetail.orderNoCnt]: string;
  [EnumDetail.closeDate]: string;
  [EnumDetail.remark]: string;
  [EnumDetail.deliverEndDate]: string;
  [EnumDetail.arriveDateTime]: string;
  [EnumDetail.billMonth]: string;
}

// #endregion

// #region MasterSort

// #endregion

// #region retailerSetup

export interface IretailerSetupRcv {
  [EnumRetailerSetup.queryConditions]: IqueryConditions;
  [EnumRetailerSetup.queryResults]: IqueryResults;
  [EnumRetailerSetup.exportItemList]: IexportItemList;
  [EnumRetailerSetup.queryDateList]: IqueryDateList[];
}
/** retailerSetup FORM表單 */
export enum EnumQueryConditions {
  retailerId = 'retailerId',
  supplierCode = 'supplierCode',
  storeNo = 'storeNo',
  receiveDate = 'receiveDate',
  orderNo = 'orderNo',
  receiveNo = 'receiveNo',
  supplierCodeLike = 'supplierCodeLike',
  queryDateSelect = 'queryDateSelect',
  queryDateBegin = 'queryDateBegin',
  queryDateEnd = 'queryDateEnd',
}
/** retailerSetup TABLE COL */
export enum EnumQueryResults {
  checkbox = 'checkbox',
  retailerId = 'retailerId',
  storeNo = 'storeNo',
  receiveNo = 'receiveNo',
  receiveDate = 'receiveDate',
  supplierCode = 'supplierCode',
  supplierBriefName = 'supplierBriefName',
  orderNo = 'orderNo',
  orderDate = 'orderDate',
  receiveStatus = 'receiveStatus',
  viewed = 'viewed',
  downloaded = 'downloaded',
  updDate = 'updDate',
  closeDate = 'closeDate',
  remark = 'remark',
  deliverEndDate = 'deliverEndDate',
  arriveDateTime = 'arriveDateTime',
  billMonth = 'billMonth',
}

export interface IqueryConditions {
  [EnumQueryConditions.retailerId]: boolean;
  [EnumQueryConditions.supplierCode]: boolean;
  [EnumQueryConditions.storeNo]: boolean;
  [EnumQueryConditions.receiveDate]: boolean;
  [EnumQueryConditions.orderNo]: boolean;
  [EnumQueryConditions.receiveNo]: boolean;
  [EnumQueryConditions.supplierCodeLike]: boolean;
  [EnumQueryConditions.queryDateSelect]: boolean;
}

export interface IqueryResults {
  [EnumQueryResults.checkbox]: boolean;
  [EnumQueryResults.retailerId]: boolean;
  [EnumQueryResults.storeNo]: boolean;
  [EnumQueryResults.receiveNo]: boolean;
  [EnumQueryResults.receiveDate]: boolean;
  [EnumQueryResults.supplierCode]: boolean;
  [EnumQueryResults.supplierBriefName]: boolean;
  [EnumQueryResults.orderNo]: boolean;
  [EnumQueryResults.orderDate]: boolean;
  [EnumQueryResults.receiveStatus]: boolean;
  [EnumQueryResults.viewed]: boolean;
  [EnumQueryResults.downloaded]: boolean;
  [EnumQueryResults.updDate]: boolean;
  [EnumQueryResults.closeDate]: boolean;
  [EnumQueryResults.remark]: boolean;
  [EnumQueryResults.deliverEndDate]: boolean;
  [EnumQueryResults.arriveDateTime]: boolean;
  [EnumQueryResults.billMonth]: boolean;
}

export const initRetailerSetup: IretailerSetupRcv = {
  [EnumRetailerSetup.queryConditions]: {
    [EnumQueryConditions.retailerId]: true,
    [EnumQueryConditions.supplierCode]: false,
    [EnumQueryConditions.storeNo]: false,
    [EnumQueryConditions.receiveDate]: false,
    [EnumQueryConditions.orderNo]: false,
    [EnumQueryConditions.receiveNo]: false,
    [EnumQueryConditions.supplierCodeLike]: false,
    [EnumQueryConditions.queryDateSelect]: false,
  },
  [EnumRetailerSetup.queryResults]: {
    [EnumQueryResults.checkbox]: true,
    [EnumQueryResults.retailerId]: true,
    [EnumQueryResults.storeNo]: true,
    [EnumQueryResults.receiveNo]: true,
    [EnumQueryResults.receiveDate]: true,
    [EnumQueryResults.supplierCode]: false,
    [EnumQueryResults.supplierBriefName]: false,
    [EnumQueryResults.orderNo]: false,
    [EnumQueryResults.orderDate]: false,
    [EnumQueryResults.receiveStatus]: false,
    [EnumQueryResults.viewed]: false,
    [EnumQueryResults.downloaded]: false,
    [EnumQueryResults.updDate]: true,
    [EnumQueryResults.closeDate]: false,
    [EnumQueryResults.remark]: false,
    [EnumQueryResults.deliverEndDate]: false,
    [EnumQueryResults.arriveDateTime]: false,
    [EnumQueryResults.billMonth]: false,
  },
  [EnumRetailerSetup.exportItemList]: initExportItemList,
  [EnumRetailerSetup.queryDateList]: [],
};
// #endregion

// #region Form

export interface RcvQueryForm {
  master: Imaster;
  masterSort: IquerySort[];
}
export interface RcvQueryFormDetail {
  detail: Idetail[];
  master: Imaster;
  pageObj: Ipage;
  masterSort: IquerySort[];
}

// #endregion

// #region state

export interface RcvQueryState {
  /** input */
  master: Imaster;
  /** form的排序 */
  masterSort: IquerySort[];
  detail: Idetail[];
  pageObj: Ipage;
  /** 體系別option */
  retailerTypeOption: Ioption[];
  showResult: boolean;
  /** 操作歷程 畫面開關 */
  showLogRecordModal: boolean;
  /** 操作歷程 資料 */
  logRecordData: IlogRecordQuery[];
  queryDateList: IqueryDateList[];
}
export enum EnumQueryDateSelect {
  選項值 = 'optionId',
  選項名稱 = 'propertyName',
  預設起始天數 = 'beginDate',
  預設結束天數 = 'endDate',
}

// #endregion

// #region useInit
export const useInitMaster = (): Imaster => {
  // 取得 retailerIds (動態變動) 所以要使用 useEffect 更新 Master
  const { retailerIds } = useSelector(getUserInfoReducer);
  // 舊系統轉移到新系統，retaierId會記錄到 localStorage
  // 如果沒有 localStorage 就取 retailerIds 的第一比當體系別預設值
  const defaultRetaierId =
    localStorage.getItem(localStorageRetaierIdName) ||
    retailerIds?.[0]?.retailerId ||
    '';

  return {
    [EnumMaster.retailerId]: defaultRetaierId,
    [EnumMaster.supplierCode]: [],
    [EnumMaster.storeNo]: [],
    [EnumMaster.orderStartNo]: '',
    [EnumMaster.orderEndNo]: '',
    [EnumMaster.receiveStartDate]: new Date(),
    [EnumMaster.receiveEndDate]: new Date(),
    [EnumMaster.receiveStartNo]: '',
    [EnumMaster.receiveEndNo]: '',
    [EnumMaster.supplierCodeLike]: '',
    [EnumMaster.queryDateValue]: '',
    [EnumMaster.queryDateBegin]: DATE_RANGE_DEFAULT.startDate,
    [EnumMaster.queryDateEnd]: DATE_RANGE_DEFAULT.endDate,
  };
};

// #endregion

// #region retailerSetup 控制畫面顯示

export const useInitRetailerSetup = (): IretailerSetupRcv => ({
  [EnumRetailerSetup.queryConditions]: {
    [EnumQueryConditions.retailerId]: true,
    [EnumQueryConditions.supplierCode]: false,
    [EnumQueryConditions.storeNo]: false,
    [EnumQueryConditions.receiveDate]: false,
    [EnumQueryConditions.orderNo]: false,
    [EnumQueryConditions.receiveNo]: false,
    [EnumQueryConditions.supplierCodeLike]: false,
    [EnumQueryConditions.queryDateSelect]: false,
  },
  [EnumRetailerSetup.queryResults]: {
    [EnumQueryResults.checkbox]: true,
    [EnumQueryResults.retailerId]: true,
    [EnumQueryResults.storeNo]: true,
    [EnumQueryResults.receiveNo]: true,
    [EnumQueryResults.receiveDate]: true,
    [EnumQueryResults.supplierCode]: false,
    [EnumQueryResults.supplierBriefName]: false,
    [EnumQueryResults.orderNo]: false,
    [EnumQueryResults.orderDate]: false,
    [EnumQueryResults.receiveStatus]: false,
    [EnumQueryResults.viewed]: false,
    [EnumQueryResults.downloaded]: false,
    [EnumQueryResults.updDate]: true,
    [EnumQueryResults.closeDate]: false,
    [EnumQueryResults.remark]: false,
    [EnumQueryResults.deliverEndDate]: false,
    [EnumQueryResults.arriveDateTime]: false,
    [EnumQueryResults.billMonth]: false,
  },
  [EnumRetailerSetup.exportItemList]: initExportItemList,
  [EnumRetailerSetup.queryDateList]: [],
});
// #endregion
